if (!customElements.get('comparison-table-mobile')) {
  customElements.define(
    'comparison-table-mobile',
    class ComparisonTableMobile extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.carousel = this.querySelector('flickity-carousel');
        if (!this.carousel) return;

        this.initSlider();
      }

      async initSlider() {
        const flickityInstance = await this.carousel.flickityInstance;
        if (!flickityInstance) return;

        // Handle synchronization with accordions
        const handleSlideChange = () => {
          this.updateSyncElements(flickityInstance.selectedIndex);
        };

        this.carousel.addEventListener('flickity:slide-changed', handleSlideChange);

        if (flickityInstance.initialized) {
          handleSlideChange();
        } else {
          flickityInstance.on('ready', handleSlideChange);
        }

        // Handle manual clicks/taps on slides
        flickityInstance.on('staticClick', (event, pointer, cellElement, cellIndex) => {
          if (typeof cellIndex === 'number') {
            const clickedLink = event.target.closest('a');
            if (clickedLink && !clickedLink.classList.contains('singleton-cta') && !clickedLink.classList.contains('comparison-table__cta-mobile')) {
              event.preventDefault();
            }
            flickityInstance.select(cellIndex);
          }
        });

        // Initialize state
        this.updateSyncElements(flickityInstance.selectedIndex);

        // Store slide data for syncing links
        this.slideLinks = Array.from(this.querySelectorAll('.comparison-table__mobile-slide')).map(el => {
          return el.dataset.url;
        });

        this.initAccordions();
      }

      initAccordions() {
        const accordions = this.querySelectorAll('details.accordion-details');
        accordions.forEach((details) => {
          const summary = details.querySelector('summary');
          
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            const isOpen = details.hasAttribute('open');
            
            // Close all others
            accordions.forEach((other) => {
              if (other !== details && other.hasAttribute('open')) {
                this.closeAccordion(other);
              }
            });
            
            if (isOpen) {
              this.closeAccordion(details);
            } else {
              this.openAccordion(details);
            }
          });
        });
      }

      openAccordion(details) {
        details.style.overflow = 'hidden';
        details.setAttribute('open', '');
        
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion-details__content');
        
        const startHeight = summary.offsetHeight;
        const endHeight = startHeight + content.offsetHeight;
        
        const animation = details.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], {
          duration: 300,
          easing: 'ease-in-out'
        });

        animation.onfinish = () => {
          details.style.height = '';
          details.style.overflow = '';
        };
      }

      closeAccordion(details) {
        details.style.overflow = 'hidden';
        
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion-details__content');
        
        const startHeight = summary.offsetHeight + content.offsetHeight;
        const endHeight = summary.offsetHeight;
        
        const animation = details.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], {
          duration: 300,
          easing: 'ease-in-out'
        });

        animation.onfinish = () => {
          details.removeAttribute('open');
          details.style.height = '';
          details.style.overflow = '';
        };
      }

      updateSyncElements(index) {
        // Update accordion content visibility
        const accordions = this.querySelectorAll('.accordion-item');
        accordions.forEach(accordion => {
          const activeValueDiv = accordion.querySelector(`.comparison-table__dynamic-value[data-index="${index}"]`);
          if (activeValueDiv) {
            const hasData = activeValueDiv.dataset.hasValue === 'true';
            accordion.style.display = hasData ? 'block' : 'none';
          }
        });

        // Update accordion content
        const values = this.querySelectorAll('.comparison-table__dynamic-value');
        values.forEach((val) => {
          val.style.display = parseInt(val.dataset.index) === index ? 'block' : 'none';
        });

        // Update active class for UI
        const allSlides = this.querySelectorAll('.comparison-table__mobile-slide');
        allSlides.forEach(s => s.classList.remove('is-active'));

        const activeSlide = this.querySelector(`.comparison-table__mobile-slide[data-index="${index}"]`);
        if (activeSlide) {
          activeSlide.classList.add('is-active');

          // Update singleton button link
          const singletonBtn = this.querySelector('.singleton-cta');
          const productUrl = activeSlide.dataset.url;
          if (singletonBtn && productUrl) {
            singletonBtn.setAttribute('href', productUrl);
          }
        }
      }
    }
  );
}

